import { Ha } from './chunk-QN7C32VL.js';
import { l } from './chunk-LN4SCFXG.js';
import { jsx } from 'react/jsx-runtime';

function p({children:o,theme:r="vx"}){return jsx(l,{children:jsx(Ha,{theme:r,children:o})})}function h({children:o,oldTheme:r}){return jsx(l,{children:jsx(Ha,{theme:"vx",themeOverride:r,children:o})})}function s({children:o}){return jsx(p,{theme:"gx",children:o})}async function f(o){try{await navigator.clipboard.writeText(o);}catch(r){console.error("Failed to copy text to clipboard:",r);}}function u(o,r,i){window.SvrManager=window.SvrManager||{},window.SvrManager[o]=window.SvrManager[o]||{},window.SvrManager[o][r]=i;}

export { p as a, h as b, s as c, f as d, u as e };
